var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v40H.3z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ee161f",
    fillRule: "evenodd",
    d: "M-3 30h60v10H-3zm0-30h60v10H-3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M-3 10h60v20H-3z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00a850",
    d: "M26.7 10.2c-.6 1.2-1 1.2-2 2-.4.4-1 .6-.2 1-.9.4-1.3.6-1.7 1.4l.2.2s.8-.4.8-.2c.2.2-1 .8-1.1.9l-.9.5c-1 .9-1.6.6-2.2 1.9l2-.2c.4 1.4-1 1.6-2 2.2l-1.7 1c.5 1.4 1.7.6 2.7.2l.2.2v.4l-2 1-2.5 1.5v.4q1.4.4 2.9 0c1-.4 1.2-.8 2.4-.8a8 8 0 0 1-4 1.6v.8q1.6 0 3-.2l2.6-.8c.6 0 1.3.6 1 1.2-.6 2.2-3 1.8-3.8 3.7l3.2-1.3q1.3-.7 2.7-.6c1.2.4 1.2 1.2 2.8 1.7l-.4-1 1.2.3c1 .4 1.3.9 2.5.7-1-1.3-1.2-1-2-1.9-.9-1.2-1.3-3 0-3.2l1.4.4c1.4.2 1.4-.2 3.4.6 1.3.4 1.7 1 3 .6-.5-1.4-2.8-2.4-4.2-2.8 1.6-1 1.2.4 3.5-.2v-.5c-1.6-1.2-2.3-2.2-4.5-2.2l3.5-.4v-.4l-3.5-1 .3-.3c.7.4 2.6.4 2.7.4 0-.5-1-1-1.8-1.3 0 0-3.5-2.2-3.5-2.4 0-.5 1.4.1 3 .5q-.8-1.2-2.1-1.4l1.2-.2c-.8-1.8-2.8-1.6-4-2.4-.9-.6-.9-1-2.1-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.4,
    d: "M24.5 23.7c.1-.5.3-1-.6-1.3-.9-.5.5 1.6.6 1.3m1-1c-.1 0-.2.7.2.9.4 0 0-.9-.1-.9m1.1 0c-.2 0-.2 1 .5.8s0-1-.5-.9m1.3-2.5c.1-.2 0-1.1-.6-.7s.4.8.6.7m-1.3-.7c.2-.1.2-.7-.3-.5s.2.6.3.5m-1.1.2s-.4-.5-.6-.4c-.4.3.6.4.6.4m-3.9 1.5c.2 0 1.3-.2 1.6-.6s-2 .2-2 .2zm11-2.7c0-.1-.6-.6-1-.4 0 .4 1 .5 1 .4m-2.1-1.1c0-.2-.3-.9-1.1-.5s.8.8 1 .5M28 17s.1-.7.6-.5c.6.4-.6.5-.6.5m-.5-.5q-.2-.2-1.2.3c-.5.4 1.4.1 1.2-.3m1.4-1.7s.6-.3.7 0c.2.3-.7 0-.7 0m-.4-.3c0-.2-.6-.2-.6.1-.1.3.7.2.6 0m-1.3 0s-.9 0-1.1.5c.4.2 1.3-.1 1-.5m-1.7.5s-1 .7-1.2 1.2c0 .4 1.3-.8 1.3-.8s.2-.4-.1-.4m-1.2-.5c0-.2.5-.5.6-.5q-.1.4-.6.5m.3 2.4c0-.2-1.2-.2-.7.4.4.5.8-.3.7-.4m-1.1.9q-.1-.4-.4-.5l-1 .2.5.8zm6.9 4.3c0-.2 1.3-.6 1.8-.2.5.7-1.9.4-1.8.2m3.6.8c.2-.5-1-1-1.4-.5.1.7 1.1 1 1.4.5",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLb);
export default __webpack_public_path__ + "static/media/lb.92ad79b3bc936f2872b1545271f483e3.svg";
export { ForwardRef as ReactComponent };